export const asyncLoadArrayProzessor = (...funcArgs) => (beforAddedArgs) => {
    const arrayPushAPI = {
        push(...args) {
            if (args !== undefined) {
                args.forEach((func) => {
                    if (typeof func === 'function') {
                        func(...funcArgs);
                    }
                });
            }
        },
    };
    if (beforAddedArgs && Array.isArray(beforAddedArgs)) {
        arrayPushAPI.push(...beforAddedArgs);
    }
    return arrayPushAPI;
};
